import { FlagIcon } from 'assets'
import { GenderIcon } from 'components/client/GenderIcon'
import { abbreviateName } from 'helpers'
import React from 'react'

export const ClientAvatar = ({
    genderIconUrl,
    fullname,
    duplicate,
    size = '60'
}: {
    duplicate: boolean
    genderIconUrl: string
    fullname: string
    size?: string
}) => {
    const avatarElement = [
        duplicate && (
            <div aria-label="flag icon">
                <FlagIcon height={size} width={size} />
            </div>
        ),
        genderIconUrl && (
            <GenderIcon
                src={genderIconUrl}
                size={parseInt(size, 10)}
                alt={`${fullname} avatar`}
                className="card-village-client-v2__avatar"
            />
        ),
        <div
            className="card-client-abbr card-client-abbr--name"
            style={{ width: `${size}px`, height: `${size}px` }}
            key={fullname}
        >
            {abbreviateName(fullname)}
        </div>
    ].find(Boolean)

    return <div aria-label="client-avatar">{avatarElement}</div>
}
